import { Divider, Input } from 'antd';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  inputRenameGlobal, primaryFont, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import { INVALID_RENAME_REGEX } from 'Utils/Constants';
import Cross from '../assets/svgIcons/Cross';
import Tick from '../assets/svgIcons/Tick';
import InfoIconTwoRed from '../assets/svgIcons/InfoIconTwoRed';

type Props = {
  placeholder?: string,
  errorMessage?: string,
  id: number,
  onRename: (id: number, name: string, extension: string) => void
  onCancel: () => void,
  extension?: string
  setError?: () => void
} & typeof defaultProps;

const defaultProps = {
  placeholder: '',
  errorMessage: '',
  extension: '',
  setError: () => { },
};

const Wrapper = styled.div`
&.errorInput {
  .ant-input {
    border: 1px solid #F43C45;
  }
}
width: calc(100% - 75px);
.ant-input {
  position: relative;
  ${inputRenameGlobal};
  height: 36px;
}
.error-message-div {
  position: absolute;
  bottom: 6px;
  display: flex;
  align-items: center;
  .info-icon-red {
    width: 12px;
    min-width: 12px;
    height: 12px;
    margin-right: 5px;
  }
  .text-for-error {
    color: #F43C45;
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 11px;
    font-size: 12px;
  }
}
.edit-actions-div {
  display: flex;
  align-items: center;
  position: absolute;
  right: 30px;
  top: 30px;
  .separator {
    background: rgba(0, 0, 0, 0.50);
  }
  .tick {
    svg {
      width: 15px;
      min-width: 15px;
      height: 13px;
      cursor: pointer;
    }
    &.disabled{
        pointer-events: none;
        opacity: 0.3;
      }
  }
  .cross {
    svg {
      width: 10px;
      min-width: 10px;
      height: 13px;
      cursor: pointer;
    }
  }
}
`;
const RenameTextBoxGlobal = function RenameTextBoxGlobal(props: Props) {
  const {
    placeholder, onCancel, onRename, id, errorMessage, extension, setError,
  } = props;
  const [editTitle, setEditTitle] = useState('');
  useEffect(() => {
    setEditTitle(placeholder);
  }, []);
  const onOk = () => {
    if (editTitle.length && id > 0) {
      onRename(id, editTitle.replace(INVALID_RENAME_REGEX, ' ').trim(), extension);
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditTitle(e.target.value);
    setError();
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onOk();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };
  return (
    <Wrapper className={classNames('rename-text-box-global-style-wrapper', { errorInput: errorMessage !== '' })}>
      <Input
        size="middle"
        value={editTitle}
        onChange={(e) => onChangeHandler(e)}
        onKeyDown={onKeyDown}
        maxLength={60}
      />
      {errorMessage !== '' ? (
        <div className="error-message-div">
          <InfoIconTwoRed className="info-icon-red" fillColor="rgba(244, 60, 69, 1)" />
          <span className="text-for-error text-truncate-one-line">{errorMessage}</span>
        </div>
      ) : null}
      <div className="edit-actions-div">
        <span
          className="cross"
          onClick={onCancel}
          onKeyPress={onCancel}
          role="button"
          aria-label="close"
          tabIndex={0}
        >
          <Cross />
          {/* pass on Click functionality as a prop in this svg */}
        </span>
        <Divider type="vertical" className="separator" />
        <span
          className={classNames('tick', { disabled: !editTitle.trim().length })}
          onClick={onOk}
          onKeyPress={onOk}
          role="button"
          aria-label="close"
          tabIndex={0}
        >
          <Tick />
          {/* pass on Click functionality as a prop in this svg */}

        </span>
      </div>
    </Wrapper>
  );
};
RenameTextBoxGlobal.defaultProps = defaultProps;
export default RenameTextBoxGlobal;
